import { BasePopup } from 'components/Display/BasePopup/BasePopup';
import { SetupOCRExtractor } from './SetupOCRExtractor/SetupOCRExtractor';
import { DocumentType } from 'support/types';
import { useSenderProcessSpecification } from 'services/repositories/relationships/relationships';
import { useDocumentCreationRelationship } from 'support/helpers/relationships/relationships';

type OCRSetupModalProps = {
  setOpen: (open: boolean) => void;
  open: boolean;
  sourceMessageId: string;
  documentType: DocumentType | undefined;
};

export const OCRSetupModal = ({ open, setOpen, sourceMessageId, documentType }: OCRSetupModalProps) => {
  const targetRelationship = useDocumentCreationRelationship({
    sourceMessageId,
    documentType,
  });
  const { data: senderProcessSpecification } = useSenderProcessSpecification({
    variables: { relationshipId: targetRelationship?.id, sourceMessageId },
  });

  if (!targetRelationship || !senderProcessSpecification) {
    return null;
  }

  return (
    <BasePopup setOpen={setOpen} open={open} width="fit-content" shouldGrowIndefinitely>
      <SetupOCRExtractor
        senderProcessSpecification={senderProcessSpecification}
        targetRelationship={targetRelationship}
        setOpen={setOpen}
        sourceDocumentId={sourceMessageId}
      />
    </BasePopup>
  );
};
